import React from 'react';

import './styles.css';

interface AvatarImageWithText {
  src?: string;
  initials: string;
  text: string;
}

const AvatarImageWithText = ({src, initials, text}: AvatarImageWithText) => (
  <div className="AvatarImageWithText colab-centered-v">
    <React.Fragment>
      {src && (
        <img className="AvatarImageWithText__image" src={src} alt="Image" />
      )}
      {!src && (
        <div className="AvatarImageWithText__initials colab-centered colab-bold">
          {initials}
        </div>
      )}
    </React.Fragment>
    <div className="colab-bold colab-centered">{text}</div>
  </div>
);

export default AvatarImageWithText;
